import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as alertActions from '../alerts/actions';
import { Alert } from '../alerts';

import { actions, api } from './';

export function* fetch(action) {
    const { params } = action.value

    try {
        const data = yield call(api.fetch, params)
        yield put(actions.fetchSuccess(data))
    } catch (error) {
        yield put(actions.fetchFailure(error))
    }
}

export function* create(action) {
    const { params } = action.value

    try {
        const data = yield call(api.create, params)
        yield put(actions.createSuccess(data))
    } catch (error) {
        yield put(actions.createFailure(error))
    }
}

export function* remove(action) {
    const { params } = action.value;

    try {
        const data = yield call(api.remove, params)
        yield put(actions.removeSuccess(params))
        yield put(alertActions.setAlert(
            new Alert('success', `Invite was removed`)
        ));
    } catch (error) {
        yield put(actions.removeFailure(error))
        yield put(alertActions.setAlert(new Alert('danger', "Failure. Unable to delete invite.")));
    }
}

function* watchForFetch() {
    yield takeLatest(actions.INVITES_FETCH, fetch)
    yield takeLatest(actions.INVITES_CREATE, create)
    yield takeLatest(actions.INVITES_REMOVE, remove)
}

export default function* root() {
    yield fork(watchForFetch)
}
